import React, { FC } from 'react';
import { CareersFeedFragment } from '../types/graphqlTypes';
import { Card } from './Card';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';
import { CAREERS_URLS } from '../urls';

interface CareersFeedProps extends CareersFeedFragment {
  width: 'narrow' | 'wide';
}

// JSX

export const CareersFeed: FC<Omit<CareersFeedProps, '__typename'>> = ({ title, backgroundColour, jobs, width }) => {
  if (jobs.length < 1) {
    return null;
  }

  return (
    <Section
      contained
      background={backgroundColour || 'grey'}
      customButton={{ label: `View all ${jobs.length} jobs`, url: `/${CAREERS_URLS.vacancies}`, variant: 'solid' }}
      narrow={width === 'narrow'}
      overflowHidden
    >
      <CardCarouselWrapper heading={title} width={width}>
        {jobs.map(({ name, location, employmentType, relativeUrl, maxSalary, minSalary }, index) => {
          const formattedMinSalary = minSalary ? minSalary.toLocaleString() : '';
          const formattedMaxSalary = maxSalary ? maxSalary.toLocaleString() : '';
          const formattedSalary =
            minSalary && maxSalary
              ? `£${formattedMinSalary} - £${formattedMaxSalary}`
              : `${formattedMinSalary ? `£${formattedMinSalary}` : ''}`;

          return (
            <Card
              key={index}
              heading={name}
              meta={`${location}<br>${employmentType}${formattedSalary ? `<br>${formattedSalary}` : ''}`}
              url={relativeUrl}
              actionLabel="Application details"
              backgroundColor={backgroundColour === 'white' || !backgroundColour ? 'grey1' : 'white'}
            />
          );
        })}
      </CardCarouselWrapper>
    </Section>
  );
};
